export default __webpack_public_path__ + "static/media/p39.d80d6940.jpg";